"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openTCFConsentDialog = exports.openCCPAConsentDialog = exports.initializeCMP = exports.doesGDPRApply = exports.doesCCPAApply = exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initCMP = _interopRequireDefault(require("./initCMP"));

var _logger = require("./logger");

var _getClientLocation = _interopRequireDefault(require("./getClientLocation"));

var _setDefaultUSPData = _interopRequireDefault(require("./setDefaultUSPData"));

var _updateStoredPrivacyData = _interopRequireDefault(require("./updateStoredPrivacyData"));

var _isClientSide = _interopRequireDefault(require("./isClientSide"));

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var tabCMPInitialized = false;

var requireClientSide = function requireClientSide(func) {
  return function (args) {
    if (!(0, _isClientSide.default)()) {
      throw new Error("[tab-cmp] tab-cmp cannot be called server-side.");
    }

    return func(args);
  };
};

var requireCMPInitialized = function requireCMPInitialized(func) {
  return function (args) {
    if (!tabCMPInitialized) {
      // We don't want tab-cmp to ever throw. We'd rather it fail
      // silently than disrupt its parent app.
      // Here, the onError callback won't have been provided, so just
      // log to console.
      // eslint-disable-next-line no-console
      console.error("[tab-cmp] initializeCMP must be called before calling any other tab-cmp methods.");
      return;
    } // We're fine just returning above as a substitute for throwing.
    // eslint-disable-next-line consistent-return


    return func(args);
  };
};

var catchAndLogErrors = function catchAndLogErrors(func) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(args) {
        var result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return func(args);

              case 3:
                result = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                (0, _logger.logError)(_context.t0);
                return _context.abrupt("return");

              case 10:
                return _context.abrupt("return", result);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var commonWrapper = function commonWrapper(func) {
  return requireClientSide(requireCMPInitialized(catchAndLogErrors(func)));
};

var isDebugParamSet = function isDebugParamSet() {
  var isDebug = false;

  try {
    var urlStr = (0, _utils.getURL)();
    var url = new URL(urlStr);
    var tabCMPDebug = url.searchParams.get('tabCMPDebug');
    isDebug = tabCMPDebug === 'true';
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return isDebug;
};

var initializeCMP = requireClientSide(
/*#__PURE__*/
(0, _asyncToGenerator2.default)(
/*#__PURE__*/
_regenerator.default.mark(function _callee2() {
  var userOptions,
      options,
      isInUS,
      isInEuropeanUnion,
      _yield$getClientLocat,
      _args2 = arguments;

  return _regenerator.default.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          userOptions = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};

          if (!tabCMPInitialized) {
            _context2.next = 3;
            break;
          }

          return _context2.abrupt("return");

        case 3:
          tabCMPInitialized = true;
          options = _objectSpread(_objectSpread({
            displayPersistentConsentLink: false,
            onError: function onError() {},
            primaryButtonColor: '#9d4ba3',
            publisherName: 'Tab for a Cause',
            publisherLogo: 'https://tab.gladly.io/static/logo-with-text-257bbffc6dcac5076e8ac31eed8ff73c.svg'
          }, userOptions), {}, {
            debug: isDebugParamSet() ? true : userOptions.debug || false
          });

          try {
            // Set up error and debug logging.
            (0, _logger.setUpLogger)({
              debug: options.debug,
              onErrorCallback: options.onError
            });
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("[tab-cmp] Failed to set up logger.", e);
          }

          _context2.prev = 6;
          (0, _logger.logDebugging)("Called initializeCMP with options:", options); // Determine the client location to know which privacy laws apply.

          isInUS = false;
          isInEuropeanUnion = false;
          _context2.prev = 10;
          ;
          _context2.next = 14;
          return (0, _getClientLocation.default)();

        case 14:
          _yield$getClientLocat = _context2.sent;
          isInUS = _yield$getClientLocat.isInUS;
          isInEuropeanUnion = _yield$getClientLocat.isInEuropeanUnion;
          _context2.next = 21;
          break;

        case 19:
          _context2.prev = 19;
          _context2.t0 = _context2["catch"](10);

        case 21:
          (0, _logger.logDebugging)("Client location. isInEU: ".concat(isInEuropeanUnion, ". isInUS: ").concat(isInUS)); // Set (as needed) the tab-cmp window variable. Then, set whether
          // GDPR and CCPA apply, if not set already. We use these values
          // in the modified version of the Quantcast Choice CMP JS.
          // window.tabCMP structure:
          //   {Boolean} doesGDPRApply
          //   {Boolean} doesCCPAApply
          //   {Function} uspStubFunction (set in head script)

          window.tabCMP = window.tabCMP || {};
          window.tabCMP.doesGDPRApply = Object.prototype.hasOwnProperty.call(window.tabCMP, 'doesGDPRApply') ? window.tabCMP.doesGDPRApply : isInEuropeanUnion;
          window.tabCMP.doesCCPAApply = Object.prototype.hasOwnProperty.call(window.tabCMP, 'doesCCPAApply') ? window.tabCMP.doesCCPAApply : isInUS; // Initialize our modified version of Quantcast Choice.

          (0, _initCMP.default)(options); // We need to set the default USP data, which QC Choice does
          // not do automatically.

          (0, _setDefaultUSPData.default)(); // Sync our TCF/USP data in local storage to the CMP.

          (0, _updateStoredPrivacyData.default)();
          _context2.next = 33;
          break;

        case 30:
          _context2.prev = 30;
          _context2.t1 = _context2["catch"](6);
          (0, _logger.logError)(_context2.t1);

        case 33:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[6, 30], [10, 19]]);
})));
exports.initializeCMP = initializeCMP;
var doesGDPRApply = commonWrapper(
/*#__PURE__*/
(0, _asyncToGenerator2.default)(
/*#__PURE__*/
_regenerator.default.mark(function _callee3() {
  var _yield$getClientLocat2, isInEuropeanUnion;

  return _regenerator.default.wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _getClientLocation.default)();

        case 2:
          _yield$getClientLocat2 = _context3.sent;
          isInEuropeanUnion = _yield$getClientLocat2.isInEuropeanUnion;
          (0, _logger.logDebugging)("Called doesGDPRApply. Response: ".concat(isInEuropeanUnion));
          return _context3.abrupt("return", isInEuropeanUnion);

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3);
})));
exports.doesGDPRApply = doesGDPRApply;
var doesCCPAApply = commonWrapper(
/*#__PURE__*/
(0, _asyncToGenerator2.default)(
/*#__PURE__*/
_regenerator.default.mark(function _callee4() {
  var _yield$getClientLocat3, isInUS;

  return _regenerator.default.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _getClientLocation.default)();

        case 2:
          _yield$getClientLocat3 = _context4.sent;
          isInUS = _yield$getClientLocat3.isInUS;
          (0, _logger.logDebugging)("Called doesCCPAApply. Response: ".concat(isInUS));
          return _context4.abrupt("return", isInUS);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
})));
exports.doesCCPAApply = doesCCPAApply;
var openTCFConsentDialog = commonWrapper(
/*#__PURE__*/
(0, _asyncToGenerator2.default)(
/*#__PURE__*/
_regenerator.default.mark(function _callee5() {
  return _regenerator.default.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          (0, _logger.logDebugging)("Called openTCFConsentDialog.");

          window.__tcfapi('displayConsentUi', 2, function () {});

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5);
})));
exports.openTCFConsentDialog = openTCFConsentDialog;
var openCCPAConsentDialog = commonWrapper(
/*#__PURE__*/
(0, _asyncToGenerator2.default)(
/*#__PURE__*/
_regenerator.default.mark(function _callee6() {
  return _regenerator.default.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          (0, _logger.logDebugging)("Called openCCPAConsentDialog.");

          window.__uspapi('displayUspUi');

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})));
exports.openCCPAConsentDialog = openCCPAConsentDialog;
var _default = {
  initializeCMP: initializeCMP,
  doesGDPRApply: doesGDPRApply,
  doesCCPAApply: doesCCPAApply,
  openTCFConsentDialog: openTCFConsentDialog,
  openCCPAConsentDialog: openCCPAConsentDialog
};
exports.default = _default;